module.exports = __webpack_public_path__ + "static/img/game-logo-pp.47634d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-pp.png
// module id = SLr9
// module chunks = 0 1 2 3 4 5 6